import script from "./SidebarComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarComponent.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarComponent.vue?vue&type=style&index=0&id=5e4fcea5&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/MONICAS/FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e4fcea5"]])

export default __exports__